/* Euronavigate WhatsApp CTA visibility & localization — EN/AZ/ES/FR */
(() => {
  const locale = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const messages = {
    en: {
      cta: 'Chat with us', greeting: 'Tell us your vehicle brand, model and year so we can recommend compatible options.',
      title: 'Hi there 👋', description: 'Tell us your vehicle brand, model and year so we can recommend compatible options.',
      note: 'We typically reply within a few minutes', email: 'Support email',
      online: 'Online', offline: 'Offline', soon: 'I will be back soon'
    },
    az: {
      cta: 'Bizimlə yazışın', greeting: 'Avtomobilinizin markasını, modelini və ilini yazın. Sizə uyğun seçimləri təqdim edək.',
      title: 'Salam 👋', description: 'Avtomobilinizin markasını, modelini və ilini yazın. Sizə uyğun seçimləri təqdim edək.',
      note: 'Adətən bir neçə dəqiqə ərzində cavab veririk', email: 'E-poçt dəstəyi',
      online: 'Onlayn', offline: 'Oflayn', soon: 'Tezliklə geri dönəcəyəm'
    },
    es: {
      cta: 'Chatea con nosotros', greeting: 'Dinos la marca, el modelo y el año de tu vehículo para recomendarte opciones compatibles.',
      title: '¡Hola! 👋', description: 'Indícanos la marca, el modelo y el año de tu vehículo para recomendarte opciones compatibles.',
      note: 'Normalmente respondemos en pocos minutos.', email: 'Asistencia por correo',
      online: 'En línea', offline: 'Desconectado', soon: 'Vuelvo pronto'
    },
    fr: {
      cta: 'Discutez avec nous', greeting: 'Indiquez la marque, le modèle et l’année de votre véhicule pour obtenir des conseils adaptés.',
      title: 'Bonjour ! 👋', description: 'Indiquez la marque, le modèle et l’année de votre véhicule pour recevoir des recommandations compatibles.',
      note: 'Nous répondons généralement en quelques minutes.', email: 'Assistance par e-mail',
      online: 'En ligne', offline: 'Hors ligne', soon: 'Je reviens bientôt'
    }
  };
  const msg = messages[locale] || messages.en;
  const sourceStrings = {
    'Hi there 👋': 'title',
    'Just tell us your car brand and year of manufacture, we will offer you the options that are available': 'description',
    'Just tell us your car brand and year of manufacture, and we will offer you the options that are available.': 'description',
    'We typically reply within a few minutes': 'note',
    'Support email': 'email',
    'Chat with us': 'cta',
    'I will be back soon': 'soon',
    'Online': 'online',
    'Offline': 'offline'
  };
  const selectors = [
    ['#rawa-button .rawa-button-label', 'cta'],
    ['#rawa-box .rawa-title', 'title'],
    ['#rawa-box .rawa-description', 'description'],
    ['#rawa-box .rawa-note', 'note']
  ];
  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }
  function apply(widget) {
    if (!widget || !widget.isConnected) return;
    const button = widget.querySelector('#rawa-button');
    if (button && !widget.classList.contains('rawa-opened') && !button.querySelector('.rawa-button-label')) {
      const label = document.createElement('div');
      label.className = 'rawa-button-label';
      label.textContent = msg.cta;
      button.prepend(label);
    }
    for (const [selector, key] of selectors) widget.querySelectorAll(selector).forEach(el => setText(el, msg[key]));
    const greeting = widget.querySelector('#rawa-greeting');
    if (greeting) {
      const node = Array.from(greeting.childNodes).find(n => n.nodeType === Node.TEXT_NODE);
      if (node) setText(node, msg.greeting);
    }
    // Only match known app UI text, never arbitrary customer chat messages.
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest('.rawa-chat,.rawa-footer textarea')) continue;
      const key = sourceStrings[node.textContent.trim()];
      if (key && node.textContent !== msg[key]) node.textContent = msg[key];
    }
  }
  let widgetObserver;
  function connect() {
    const widget = document.getElementById('rawa-widget');
    if (!widget || widgetObserver) return false;
    apply(widget);
    widgetObserver = new MutationObserver(() => apply(widget));
    widgetObserver.observe(widget, { childList: true, subtree: true, characterData: true });
    return true;
  }
  function init() {
    if (connect()) return;
    const pending = new MutationObserver(() => {
      if (connect()) pending.disconnect();
    });
    pending.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();


/* Euronavigate: accessible controls for the RoarTheme contact widget. */
(() => {
  const lang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const words = {
    en: {open:'Open support chat', close:'Close support chat', greeting:'Dismiss message', wa:'Contact Michael on WhatsApp', email:'Contact support by email'},
    fr: {open:'Ouvrir le chat d’assistance', close:'Fermer le chat d’assistance', greeting:'Fermer le message', wa:'Contacter Michael sur WhatsApp', email:'Contacter l’assistance par e-mail'},
    es: {open:'Abrir chat de asistencia', close:'Cerrar chat de asistencia', greeting:'Cerrar mensaje', wa:'Contactar a Michael por WhatsApp', email:'Contactar con asistencia por correo'},
    az: {open:'Dəstək çatını aç', close:'Dəstək çatını bağla', greeting:'Mesajı bağla', wa:'Michael ilə WhatsApp-da əlaqə', email:'Dəstəklə e-poçtla əlaqə'}
  }[lang] || {open:'Open support chat', close:'Close support chat', greeting:'Dismiss message', wa:'Contact Michael on WhatsApp', email:'Contact support by email'};
  const wired = new WeakSet();
  let activeWidget;
  function button(el, label) {
    if (!el) return;
    if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    if (!el.hasAttribute('tabindex')) el.tabIndex = 0;
    el.setAttribute('aria-label', label);
    if (wired.has(el)) return;
    wired.add(el);
    el.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      el.click();
      if (el.id === 'rawa-button' || el.id === 'rawa-close') {
        setTimeout(() => {
          const isOpen = el.closest('#rawa-widget')?.classList.contains('rawa-opened');
          el.closest('#rawa-widget')?.querySelector(isOpen ? '#rawa-close' : '#rawa-button')?.focus();
        }, 350);
      }
    });
  }
  function setup() {
    const widget = document.getElementById('rawa-widget');
    if (!widget) return;
    const toggle = widget.querySelector('#rawa-button');
    const opened = widget.classList.contains('rawa-opened');
    button(toggle, opened ? words.close : words.open);
    if (toggle) {
      toggle.setAttribute('aria-expanded', String(opened));
      toggle.setAttribute('aria-controls', 'rawa-box');
      toggle.tabIndex = opened ? -1 : 0;
    }
    const close = widget.querySelector('#rawa-close');
    button(close, words.close);
    if (close) close.tabIndex = opened ? 0 : -1;
    button(widget.querySelector('#rawa-greeting-close'), words.greeting);
    widget.querySelectorAll('.rawa-account').forEach(account => {
      if (account.querySelector('.rawa-button--whatsapp')) button(account, words.wa);
      else if (account.querySelector('.rawa-button--email')) button(account, words.email);
      account.tabIndex = opened ? 0 : -1;
    });
    if (widget !== activeWidget) {
      activeWidget = widget;
      new MutationObserver(setup).observe(widget, {attributes:true, attributeFilter:['class'], childList:true, subtree:true});
      widget.addEventListener('keydown', event => {
        if (event.key === 'Escape' && widget.classList.contains('rawa-opened')) {
          event.preventDefault();
          widget.querySelector('#rawa-close')?.click();
          requestAnimationFrame(() => widget.querySelector('#rawa-button')?.focus());
        }
      });
    }
  }
  function init() {
    const style = document.createElement('style');
    style.textContent = '#rawa-widget [role="button"]:focus-visible { outline: 3px solid #ff7900; outline-offset: 3px; }';
    document.head.appendChild(style);
    setup();
    new MutationObserver(() => { if (!activeWidget || !activeWidget.isConnected) setup(); }).observe(document.documentElement, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
